import { useEffect } from 'react';
import { useAuthService } from '../utils/AuthServiceContext';

function AuthRedirect() {
  const authService = useAuthService();
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    authService.authorizeRedirect();
  }, [authService]);
  return null;
}

export default AuthRedirect;
